import type { SVGProps } from 'react'
const SvgSySignInSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M16.633 6.544 10.316 4.44A1 1 0 0 0 9 5.387v13.226a1 1 0 0 0 1.316.948l6.317-2.105A2 2 0 0 0 18 15.559V8.442a2 2 0 0 0-1.367-1.898"
		/>
		<path d="M11.146 9.146a.5.5 0 0 0 0 .708l1.647 1.646H4a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h8.793l-1.647 1.646a.5.5 0 0 0 0 .708.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 14.5 12a.5.5 0 0 0-.146-.354l-2.5-2.5a.5.5 0 0 0-.708 0" />
	</svg>
)
export default SvgSySignInSquare
